import React, { useState, useRef, useEffect, Fragment } from 'react';
import snapImg from './assets/cSWrcZcB.png';
import snapReverseImg from './assets/rsRlAjMp.png';
import snapSound from './assets/AIMsqmnV.mp3';
import snapReverseSound from './assets/cHBfBHfv.mp3';
import './assets/GxoNiTOF.css';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var repeatPosition = function repeatPosition(position) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (count <= 1) return [position];
  var positions = [];

  for (var i = 0; i < count; i++) {
    positions.push(position);
  }

  return positions;
};

var snapPositions = [["-24px -9px", ["43px", "69px"]], ["-104px -8px", ["43px", "69px"]], ["-184px -8px", ["43px", "69px"]], ["-260px -12px", ["40px", "66px"]], ["-340px -12px", ["40px", "66px"]], ["-419px -10px", ["38px", "67px"]], ["-499px -10px", ["38px", "67px"]], ["-580px -7px", ["38px", "69px"]], ["-660px -7px", ["38px", "69px"]], ["-740px -7px", ["38px", "69px"]], ["-820px -7px", ["38px", "69px"]], ["-900px -7px", ["38px", "69px"]], ["-980px -7px", ["38px", "69px"]], ["-1060px -7px", ["38px", "69px"]], ["-1140px -7px", ["38px", "69px"]], ["-1220px -7px", ["38px", "69px"]], ["-1300px -7px", ["38px", "69px"]]].concat(_toConsumableArray(repeatPosition(["-1380px -7px", ["38px", "69px"]], 25)), [["-1455px -13px", ["48px", "57px"]]], _toConsumableArray(repeatPosition(["-1541px -4px", ["41px", "69px"]], 5)), [["-1606px -4px", ["56px", "69px"], ["-15px"]], ["-1686px -9px", ["55px", "69px"], ["-15px"]], ["-1760px -9px", ["61px", "69px"], ["-20px"]], ["-1840px -9px", ["61px", "69px"], ["-20px"]], ["-1920px -9px", ["61px", "69px"], ["-20px"]]], _toConsumableArray(repeatPosition(["-2000px -8px", ["61px", "69px"], ["-20px"]], 8)), [["-2080px -8px", ["61px", "69px"], ["-20px"]]], _toConsumableArray(repeatPosition(["-2160px -8px", ["61px", "69px"], ["-20px"]], 3)), _toConsumableArray(repeatPosition(["-2240px -8px", ["61px", "69px"], ["-20px"]], 40)), [["-3200px -9px", ["61px", "69px"], ["-20px"]], ["-3280px -9px", ["61px", "69px"], ["-20px"]], ["-3360px -9px", ["61px", "69px"], ["-20px"]], ["-3441px -9px", ["61px", "69px"], ["-20px"]], ["-3540px -9px", ["41px", "69px"]], ["-3620px -12px", ["40px", "66px"]]], _toConsumableArray(repeatPosition(["-3700px -12px", ["40px", "66px"]], 3)), [["-3784px -9px", ["43px", "69px"]]]);
var snapReversePositions = [["-24px -9px", ["43px", "66px"]], ["-104px -9px", ["43px", "66px"]], ["-184px -9px", ["43px", "66px"]]].concat(_toConsumableArray(repeatPosition(["-264px -7px", ["43px", "66px"]], 4)), [["-342px -8px", ["52px", "69px"]]], _toConsumableArray(repeatPosition(["-423px -7px", ["42px", "66px"]], 2)), _toConsumableArray(repeatPosition(["-502px -7px", ["41px", "66px"]], 5)), _toConsumableArray(repeatPosition(["-582px -7px", ["58px", "66px"]], 3)), _toConsumableArray(repeatPosition(["-660px -7px", ["60px", "66px"], ["-3px"]], 5)), [["-740px -7px", ["60px", "66px"], ["-3px"]]], _toConsumableArray(repeatPosition(["-810px -7px", ["66px", "66px"], ["-13px"]], 1)), _toConsumableArray(repeatPosition(["-883px -7px", ["80px", "66px"], ["-20px"]], 3)), _toConsumableArray(repeatPosition(["-963px -7px", ["80px", "66px"], ["-20px"]], 2)), [["-1043px -7px", ["80px", "66px"], ["-20px"]], ["-1123px -7px", ["80px", "66px"], ["-20px"]], ["-1203px -7px", ["80px", "66px"], ["-20px"]], ["-1283px -7px", ["80px", "66px"], ["-20px"]]], _toConsumableArray(repeatPosition(["-1363px -7px", ["80px", "66px"], ["-20px"]], 2)), _toConsumableArray(repeatPosition(["-1443px -7px", ["80px", "66px"], ["-20px"]], 2)), _toConsumableArray(repeatPosition(["-1523px -7px", ["80px", "66px"], ["-20px"]], 2)), _toConsumableArray(repeatPosition(["-1603px -7px", ["80px", "66px"], ["-20px"]], 2)), _toConsumableArray(repeatPosition(["-1683px -7px", ["80px", "66px"], ["-20px"]], 2)), [["-1763px -7px", ["80px", "66px"], ["-20px"]], ["-1843px -7px", ["80px", "66px"], ["-20px"]], ["-1923px -7px", ["80px", "66px"], ["-20px"]], ["-2003px -7px", ["80px", "66px"], ["-20px"]], ["-2083px -7px", ["80px", "66px"], ["-20px"]], ["-2163px -7px", ["80px", "66px"], ["-20px"]], ["-2243px -7px", ["80px", "66px"], ["-20px"]], ["-2323px -7px", ["80px", "66px"], ["-20px"]], ["-2403px -7px", ["80px", "66px"], ["-20px"]], ["-2483px -7px", ["80px", "66px"], ["-20px"]], ["-2563px -7px", ["80px", "66px"], ["-20px"]], ["-2643px -7px", ["80px", "66px"], ["-20px"]], ["-2723px -7px", ["80px", "66px"], ["-20px"]], ["-2803px -7px", ["80px", "66px"], ["-20px"]], ["-2883px -7px", ["80px", "66px"], ["-20px"]], ["-2963px -7px", ["80px", "66px"], ["-20px"]], ["-3043px -7px", ["80px", "66px"], ["-20px"]]], _toConsumableArray(repeatPosition(["-3123px -7px", ["80px", "66px"], ["-20px"]], 3)), _toConsumableArray(repeatPosition(["-3203px -7px", ["80px", "66px"], ["-20px"]], 3)), _toConsumableArray(repeatPosition(["-3283px -7px", ["80px", "66px"], ["-20px"]], 3)), _toConsumableArray(repeatPosition(["-3363px -7px", ["80px", "66px"], ["-20px"]], 4)), [["-3443px -7px", ["80px", "66px"], ["-20px"]], ["-3523px -7px", ["80px", "66px"], ["-20px"]], ["-3603px -7px", ["80px", "66px"], ["-20px"]], ["-3683px -7px", ["80px", "66px"], ["-20px"]], ["-3763px -7px", ["80px", "66px"], ["-20px"]], ["-24px -9px", ["43px", "66px"]]]);

var Thanos = function Thanos(_ref) {
  var onSnap = _ref.onSnap,
      onSnapReverse = _ref.onSnapReverse;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      snap = _useState2[0],
      setSnap = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      snapping = _useState4[0],
      setSnapping = _useState4[1];

  var _ref2 = [useRef(null), useRef(null)],
      snap$ = _ref2[0],
      snapReverse$ = _ref2[1];
  var spritePosition = 0,
      rafId = null;
  useEffect(function () {
    snap$.current.style.background = "url(".concat(snapImg, ") -24px -9px");
    snapReverse$.current.style.background = "url(".concat(snapReverseImg, ") -24px -9px");
  });

  var styleGauntlet = function styleGauntlet(styles) {
    var gauntletEl = snap ? snap$.current : snapReverse$.current;
    Object.keys(styles).forEach(function (prop) {
      gauntletEl.style[prop] = styles[prop];
    });
  };

  var animateGauntlet = function animateGauntlet() {
    var spritePositions = snap ? snapPositions : snapReversePositions;

    if (spritePositions.length === spritePosition) {
      spritePosition = 0;
      setSnapping(false);
      cancelAnimationFrame(rafId);
      setSnap(!snap);
      return snap ? onSnap() : onSnapReverse();
    }

    var _spritePositions$spri = _slicedToArray(spritePositions[spritePosition][1], 2),
        width = _spritePositions$spri[0],
        height = _spritePositions$spri[1];

    var _ref3 = spritePositions[spritePosition][2] || [0],
        _ref4 = _slicedToArray(_ref3, 1),
        marginLeft = _ref4[0];

    var _spritePositions$spri2 = _slicedToArray(spritePositions[spritePosition], 1),
        backgroundPosition = _spritePositions$spri2[0];

    styleGauntlet({
      width: width,
      height: height,
      marginLeft: marginLeft,
      backgroundPosition: backgroundPosition
    });
    spritePosition += 1;
    rafId = requestAnimationFrame(animateGauntlet);
  };

  var playSound = function playSound() {
    return snap ? new Audio(snapSound).play() : new Audio(snapReverseSound).play();
  };

  var doSnap = function doSnap() {
    if (!snapping) {
      setSnapping(true);
      playSound();
      requestAnimationFrame(animateGauntlet);
    }
  };

  return React.createElement(Fragment, null, React.createElement("div", {
    onClick: doSnap,
    className: "thanos"
  }, React.createElement("div", {
    ref: snap$,
    className: "".concat(!snap ? "hide" : "", " gauntlet")
  }), React.createElement("div", {
    ref: snapReverse$,
    className: "".concat(snap ? "hide" : "", " gauntlet")
  })));
};

Thanos.defaultProps = {
  onSnap: function onSnap() {},
  onSnapReverse: function onSnapReverse() {}
};

export default Thanos;
